/**
 * @description 绑定图片的事件
 * @author wangfupeng
 */

import Editor from '../../../editor/index'
import bindPasteVideo from './paste-video'
// import bindDropVideo from './drop-video'
import bindDragVideoSize from './drag-size'
import bindTooltipVideo from './tooltip-event'

/**
 * 绑定事件
 * @param editor 编辑器实例
 */
function bindEvent(editor: Editor): void {
    // // 粘贴图片
    bindPasteVideo(editor)

    // // // 拖拽图片
    // bindDropVideo(editor)

    // // 可再扩展其他事件...如图片 tooltip 等
    // // 拖拽图片尺寸
    bindDragVideoSize(editor)

    //Tooltip
    bindTooltipVideo(editor)
}

export default bindEvent
